import { render, staticRenderFns } from "./SelectSeatComponent.vue?vue&type=template&id=bafb8dfe&scoped=true"
import script from "./SelectSeatComponent.vue?vue&type=script&lang=js"
export * from "./SelectSeatComponent.vue?vue&type=script&lang=js"
import style0 from "./SelectSeatComponent.vue?vue&type=style&index=0&id=bafb8dfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafb8dfe",
  null
  
)

export default component.exports